import { createApiClient, createApiTestkit } from '@wix/premium-fed-sdk/@apis-infra-react';
import { createQueriesConfig } from '@wix/premium-fed-sdk/apis-infra';
const API = '/_api/premium-package-pickers-api';
const getPersonalizedDescriptionsQueryFn = async _ref => {
  let {
    httpClient,
    request
  } = _ref;
  const response = await httpClient.post(`${API}/get-personalized-descriptions`, request);
  return response.data;
};
export const PersonalizedDescriptionsQueriesConfig = createQueriesConfig({
  getPersonalizedDescriptions: {
    queryFn: getPersonalizedDescriptionsQueryFn
  }
});
export const PersonalizedDescriptionsApiClient = createApiClient(PersonalizedDescriptionsQueriesConfig);
export const PersonalizedDescriptionsApiClientTestkit = createApiTestkit(PersonalizedDescriptionsQueriesConfig);
//# sourceMappingURL=personalized-descriptions.api-client.js.map